// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3UbyM","options":"AnswerScale_options__3rS2G","selected":"AnswerScale_selected__ibtlm"};